module.exports = __webpack_public_path__ + "static/logo-detailed-ef97e78150ff5bf8fb2cc92f05deee1e.svg";